import React from 'react';

import FeedHeading from '@buyside/components/presentation/Feed/FeedHeading/feedHeading';
import HighlightedMentions from '@buyside/components/presentation/Feed/HighlightedMentions/highlightedMentions';
import HighlightedRanking from '@buyside/components/presentation/Feed/HighlightedRanking/highlightedRanking';
import ResearchItem, {
  ResearchTypes
} from '@buyside/components/presentation/ResearchItem/researchItem';
import YouTubePlayer from '@buyside/components/presentation/YouTubePlayer/youtubePlayer';

import { ActivityFeedIdeaFragment } from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

import styles from './ideaStyles.scss';

const Idea: React.FC<{
  idea: ActivityFeedIdeaFragment;
} & FeedItemComponentType> = ({
  createdAt,
  currentUser,
  eventVerb,
  idea,
  isPublic,
  shouldHighlightMention = false
}) => {
  const byRanked = idea.user?.isRanked;
  const isCurrentUser = !isPublic && idea.user?.id === currentUser?.id;

  const canViewUserDetails = !isPublic && currentUser?.canViewUserDetails;

  return (
    <div>
      {eventVerb === 'PUBLISH_IDEA' && (
        <div className={styles.feedItemHeader}>
          {shouldHighlightMention && <HighlightedMentions />}
          {!idea.anonymous && byRanked && <HighlightedRanking />}
          <FeedHeading
            createdAt={createdAt}
            headerType={eventVerb}
            showUserDetails={(!idea.anonymous && Boolean(canViewUserDetails)) || isCurrentUser}
            user={idea.user}
            idea={null}
          />
        </div>
      )}
      <div className={styles.ideaResearchItem}>
        <ResearchItem
          {...idea}
          researchType={ResearchTypes.IDEA}
          attachmentExtensions={idea.attachmentExtensions}
          isPublic={isPublic}
          showUserDetails={
            canViewUserDetails || isCurrentUser || (!isPublic && Boolean(idea?.isNonBuyside))
          }
          submittedAt={idea.posted}
          updatedAt={idea.updated}
        />
      </div>
      {idea.youtubeIds &&
        idea.youtubeIds.map(id => <YouTubePlayer key={id} height={351} videoId={id} />)}
    </div>
  );
};

export default Idea;
